import {
  compose, sortWith, ascend, prop, values, slice,
} from 'ramda';

import { MAX_DISPLAYED_LIMITS } from './constants';

export const getMinMaxLimits = ({ limits = {} }) => ({
  id: limits.id,
  min: limits.minBet || 0,
  max: limits.maxBet || 0,
});

export const sortByMinBet = compose(
  slice(0, MAX_DISPLAYED_LIMITS),
  sortWith([ ascend(prop('min')) ]),
  (limits, gameId) => values(limits).map((l) => getMinMaxLimits({ limits: l, gameId }))
);

export const isFavorite = (tableId, authGroups = []) =>
// eslint-disable-next-line implicit-arrow-linebreak
  (authGroups[0] && authGroups[0].tables && authGroups[0].tables.indexOf(tableId) !== -1);
